import { Component, Inject  } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-increase-item-count-dialog',
  templateUrl: './increase-item-count-dialog.component.html',
  styleUrls: ['./increase-item-count-dialog.component.scss']
})
export class IncreaseItemCountDialogComponent {

  minItemCount: number;
  maxItemCount: number;
  formGroup: FormGroup;

  constructor(private dialogRef: MatDialogRef<IncreaseItemCountDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.minItemCount = data.minItemCount;
    this.maxItemCount = data.maxItemCount;

    this.formGroup = new FormGroup({
      itemCount: new FormControl(this.minItemCount,
        [ Validators.required, Validators.min(this.minItemCount), Validators.max(this.maxItemCount)])
    });
  }

  onIncrease(): void {
    const itemCount = this.formGroup.value.itemCount as number;
    if (itemCount >= this.maxItemCount) {
      return;
    }
    this.formGroup.patchValue({
      itemCount: itemCount + 1
    });
  }

  onDecrease(): void {
    const itemCount = this.formGroup.value.itemCount as number;
    if (itemCount <= this.minItemCount) {
      return;
    }
    this.formGroup.patchValue({
      itemCount: itemCount - 1
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    this.dialogRef.close(this.formGroup.value.itemCount);
  }
}
